import { Component, OnInit } from '@angular/core';
declare var $: any;

@Component({
  selector: 'app-message-popup',
  templateUrl: './message-popup.component.html',
  styleUrls: ['./message-popup.component.sass']
})
export class MessagePopupComponent implements OnInit {

  
  constructor() { }

  ngOnInit() {
  }

  close(){
    $('#messageModal').modal('toggle');
  }

}



// WEBPACK FOOTER //
// ./src/app/modules/modal-window/message-popup/message-popup.component.ts